import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-800 p-4 text-center text-white">
      <p>&copy; 2024 TaxEase. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
